var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransferSide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5750",
    "data-name": "Group 5750",
    transform: "translate(0 0)",
    opacity: 0.301
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8174",
    "data-name": "Path 8174",
    d: "M23.5,26H21.833A.834.834,0,0,1,21,25.166v-3H19.5a.5.5,0,0,1-.353-.853l3.167-3.167a.5.5,0,0,1,.707,0l3.167,3.167a.5.5,0,0,1-.353.853h-1.5v3A.834.834,0,0,1,23.5,26ZM22,25h1.333V21.667a.5.5,0,0,1,.5-.5h.793l-1.959-1.959-1.959,1.959H21.5a.5.5,0,0,1,.5.5Z",
    transform: "translate(-10.334 -12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8175",
    "data-name": "Path 8175",
    d: "M13.5,21H7.833A1.835,1.835,0,0,1,6,19.167V10.833A1.835,1.835,0,0,1,7.833,9H20.166A1.835,1.835,0,0,1,22,10.833v4.333H21V10.833A.834.834,0,0,0,20.166,10H7.833A.834.834,0,0,0,7,10.833v8.333A.834.834,0,0,0,7.833,20H13.5Z",
    transform: "translate(-6 -9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8176",
    "data-name": "Path 8176",
    d: "M10.833,19.333H6.5a.5.5,0,0,1-.5-.5V14.5a.5.5,0,0,1,.5-.5h4.333a1.835,1.835,0,0,1,1.833,1.833V17.5A1.835,1.835,0,0,1,10.833,19.333ZM7,18.333h3.833a.834.834,0,0,0,.833-.833V15.833A.834.834,0,0,0,10.833,15H7Z",
    transform: "translate(-6 -10.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_276",
    "data-name": "Ellipse 276",
    cx: 0.667,
    cy: 0.667,
    r: 0.667,
    transform: "translate(2.666 5.334)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferSide);
export default __webpack_public_path__ + "static/media/transferSide.b62196a152954eab9f96180697627f0e.svg";
export { ForwardRef as ReactComponent };